<div class="shared-container">
  <ng-container *ngIf="sucesso; else formObraPerdida">
    <app-sucesso
      [mensagem]="'Obra perdida registrada com sucesso!'"
      [botaoTexto]="'Continuar'"
      (continuar)="continuar()"
    ></app-sucesso>
  </ng-container>
  <ng-template #formObraPerdida>
    <!-- Conteúdo principal -->
    <div class="form-content">
      <div class="obras-perdidas">
        <label for="taskDescription">Descreva o Relato sobre a Perda</label>
        <textarea
          id="taskDescription"
          class="form-control"
          [(ngModel)]="taskDescription"
          placeholder="Descreva o relato sobre a perda..."
        ></textarea>
      </div>

      <div class="obras-perdidas">
        <select
          id="responsavel"
          class="form-control custom-select"
          [(ngModel)]="responsavelSelecionado"
          [ngClass]="{
            'is-invalid': campoObrigatorioErro && !responsavelSelecionado
          }"
          required
        >
          <option value="">Selecione o responsável</option>
          <option *ngFor="let option of responsavel" [ngValue]="option.id">
            {{ option.name }}
          </option>
        </select>
        <div
          *ngIf="campoObrigatorioErro && !responsavelSelecionado"
          class="campo-obrigatorio-msg"
        >
          Campo obrigatório!
        </div>
      </div>

      <div class="obras-perdidas">
        <select
          id="concorrente"
          class="form-control custom-select"
          [(ngModel)]="concorrenteSelecionado"
          [ngClass]="{ 'is-invalid': campoObrigatorioErro && !concorrenteSelecionado }"
          required
        >
          <option value="">Selecione o concorrente</option>
          <option
            *ngFor="let concorrente of Arrconcorrentes"
            [ngValue]="concorrente.id"
          >
            {{ concorrente.description }}
          </option>
        </select>
        <div
          *ngIf="campoObrigatorioErro && !concorrenteSelecionado"
          class="campo-obrigatorio-msg"
        >
          Campo obrigatório!
        </div>
      </div>

      <div class="obras-perdidas">
        <select
          id="motivo"
          class="form-control custom-select"
          [(ngModel)]="motivoSelecionado"
          [ngClass]="{
            'is-invalid': campoObrigatorioErro && !motivoSelecionado
          }"
          required
        >
          <option value="" selected>Qual o motivo da perda?</option>
          <option *ngFor="let motivo of ArrMotivos" [ngValue]="motivo.id">
            {{ motivo.description }}
          </option>
        </select>
        <div
          *ngIf="campoObrigatorioErro && !motivoSelecionado"
          class="campo-obrigatorio-msg"
        >
          Campo obrigatório!
        </div>
      </div>
    </div>

    <!-- Rodapé fixado -->
    <div class="footer-actions">
      <button class="btn btn-secondary" type="button" (click)="clear()">
        Limpar Dados
      </button>
      <button
        class="btn btn-primary"
        type="button"
        (click)="atualizarObraPerdida()"
      >
        Obra Perdida
      </button>
    </div>
  </ng-template>
</div>
